import React, { useEffect } from "react";
import "~/css/FontSize.css";
import { useAtom } from "jotai/index";
import { fontSizeAtom, volumeAtom, standbyModeAtom } from "~/Atom";
import { PlaySound } from "~/SoundUtils";
import { useTranslation } from "react-i18next";
import { talkModes } from "~/Commons";

const FontSize: React.FC = () => {
  const [selectedSize, setSelectedSize] = useAtom(fontSizeAtom);
  const [volume] = useAtom(volumeAtom);
  const { t } = useTranslation();
  const [standbyMode] = useAtom(standbyModeAtom);

  const handleSizeChange = (size: string) => {
    setSelectedSize(size);
    switch (size) {
      case "small":
        document.documentElement.style.fontSize = "75%";
        break;
      case "medium":
        document.documentElement.style.fontSize = "100%";
        break;
      case "large":
        document.documentElement.style.fontSize = "125%";
        break;
      default:
        document.documentElement.style.fontSize = "100%";
        break;
    }
  };

  // スタンバイモードに移行時、フォントサイズを中に設定
  useEffect(() => {
    if (standbyMode === talkModes.standby && selectedSize !== "medium") {
      handleSizeChange("medium");
    }
  }, [standbyMode, selectedSize]);

  return (
    <div className="font-size-container">
      <span>{t("fontsize")}</span>
      <button
        className={`toggle-button ${selectedSize === "small" ? "selected" : ""}`}
        onClick={() => handleSizeChange("small")}
        onMouseUp={() => PlaySound("push", volume)}
      >
        {t("small")}
      </button>
      <button
        className={`toggle-button ${selectedSize === "medium" ? "selected" : ""}`}
        onClick={() => handleSizeChange("medium")}
        onMouseUp={() => PlaySound("push", volume)}
      >
        {t("medium")}
      </button>
      <button
        className={`toggle-button ${selectedSize === "large" ? "selected" : ""}`}
        onClick={() => handleSizeChange("large")}
        onMouseUp={() => PlaySound("push", volume)}
      >
        {t("large")}
      </button>
    </div>
  );
};

export default FontSize;
